// Generated by `pnpm permissions` from parkapp-permission-contract v3.47.0 - do not edit.
import permissionContract from './dictionary/contract.json' with { type: 'json' };
import activityPermissionDomain from './dictionary/permissions/activity.json' with { type: 'json' };
import bankStatementPermissionDomain from './dictionary/permissions/bankStatement.json' with { type: 'json' };
import billingPermissionDomain from './dictionary/permissions/billing.json' with { type: 'json' };
import buttonPermissionDomain from './dictionary/permissions/button.json' with { type: 'json' };
import gatePermissionDomain from './dictionary/permissions/gate.json' with { type: 'json' };
import invitationPermissionDomain from './dictionary/permissions/invitation.json' with { type: 'json' };
import journalEntryPermissionDomain from './dictionary/permissions/journalEntry.json' with { type: 'json' };
import liftPermissionDomain from './dictionary/permissions/lift.json' with { type: 'json' };
import notificationPermissionDomain from './dictionary/permissions/notification.json' with { type: 'json' };
import orderPermissionDomain from './dictionary/permissions/order.json' with { type: 'json' };
import organizationPermissionDomain from './dictionary/permissions/organization.json' with { type: 'json' };
import parkingPermissionDomain from './dictionary/permissions/parking.json' with { type: 'json' };
import parkingMonthlyStatementPermissionDomain from './dictionary/permissions/parkingMonthlyStatement.json' with { type: 'json' };
import paymentPermissionDomain from './dictionary/permissions/payment.json' with { type: 'json' };
import pilotPermissionDomain from './dictionary/permissions/pilot.json' with { type: 'json' };
import remunerationPermissionDomain from './dictionary/permissions/remuneration.json' with { type: 'json' };
import reservationPermissionDomain from './dictionary/permissions/reservation.json' with { type: 'json' };
import salesDocumentPermissionDomain from './dictionary/permissions/salesDocument.json' with { type: 'json' };
import shopOrderPermissionDomain from './dictionary/permissions/shopOrder.json' with { type: 'json' };
import shopPaymentPermissionDomain from './dictionary/permissions/shopPayment.json' with { type: 'json' };
import ticketPermissionDomain from './dictionary/permissions/ticket.json' with { type: 'json' };
import unauthorizedUseCasePermissionDomain from './dictionary/permissions/unauthorizedUseCase.json' with { type: 'json' };
import unauthorizedUsePaymentPermissionDomain from './dictionary/permissions/unauthorizedUsePayment.json' with { type: 'json' };
import userPermissionDomain from './dictionary/permissions/user.json' with { type: 'json' };
import userVehiclePermissionDomain from './dictionary/permissions/userVehicle.json' with { type: 'json' };
import walletPermissionDomain from './dictionary/permissions/wallet.json' with { type: 'json' };
import withdrawalPermissionDomain from './dictionary/permissions/withdrawal.json' with { type: 'json' };
import permissionRoles from './dictionary/roles.json' with { type: 'json' };
/** Manifest of the contract: its version, the scopes a role may be granted in, and its domain files. */
export const PERMISSION_CONTRACT = permissionContract;
/** Every role the contract declares, with the scope it may be granted in. */
export const PERMISSION_ROLES = permissionRoles;
/** Every permission domain of the contract, keyed by the path the manifest lists it under. */
export const PERMISSION_DOMAINS = {
    'permissions/activity.json': activityPermissionDomain,
    'permissions/bankStatement.json': bankStatementPermissionDomain,
    'permissions/billing.json': billingPermissionDomain,
    'permissions/button.json': buttonPermissionDomain,
    'permissions/gate.json': gatePermissionDomain,
    'permissions/invitation.json': invitationPermissionDomain,
    'permissions/journalEntry.json': journalEntryPermissionDomain,
    'permissions/lift.json': liftPermissionDomain,
    'permissions/notification.json': notificationPermissionDomain,
    'permissions/order.json': orderPermissionDomain,
    'permissions/organization.json': organizationPermissionDomain,
    'permissions/parking.json': parkingPermissionDomain,
    'permissions/parkingMonthlyStatement.json': parkingMonthlyStatementPermissionDomain,
    'permissions/payment.json': paymentPermissionDomain,
    'permissions/pilot.json': pilotPermissionDomain,
    'permissions/remuneration.json': remunerationPermissionDomain,
    'permissions/reservation.json': reservationPermissionDomain,
    'permissions/salesDocument.json': salesDocumentPermissionDomain,
    'permissions/shopOrder.json': shopOrderPermissionDomain,
    'permissions/shopPayment.json': shopPaymentPermissionDomain,
    'permissions/ticket.json': ticketPermissionDomain,
    'permissions/unauthorizedUseCase.json': unauthorizedUseCasePermissionDomain,
    'permissions/unauthorizedUsePayment.json': unauthorizedUsePaymentPermissionDomain,
    'permissions/user.json': userPermissionDomain,
    'permissions/userVehicle.json': userVehiclePermissionDomain,
    'permissions/withdrawal.json': withdrawalPermissionDomain,
    'permissions/wallet.json': walletPermissionDomain,
};
